import React, { useState,useEffect } from 'react';
import { Box, Typography, Link, Button, Stack, IconButton, Modal } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import ContactUs from '../components/ContactUs';
import CloseIcon from '@mui/icons-material/Close';
import { socialMedia } from '../assets/Json/staticData';
import { useLocation } from 'react-router';

const Footer = () => {
  const [open, setOpen] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const [isShortPage, setIsShortPage] = useState(false);
  const location = useLocation();

  const handleOpen = () => setOpen(!open);
    // Function to check if the page is at the bottom
    const checkIfAtBottom = () => {
      const bottom = window.innerHeight + window.scrollY + 100 >= document.documentElement.scrollHeight;
      setIsAtBottom(bottom);
        const windowHeight = window.innerHeight;
    const contentHeight = document.documentElement.scrollHeight;
    const scrolledHeight = window.scrollY + windowHeight;
    
    setIsAtBottom(scrolledHeight + 100 >= contentHeight);
    setIsShortPage(contentHeight <= windowHeight);
    };
  
    // Add scroll event listener on component mount and remove on unmount
    useEffect(() => {
      checkIfAtBottom()
      window.addEventListener('scroll', checkIfAtBottom);
  
      // Clean up event listener on component unmount
      return () => {
        window.removeEventListener('scroll', checkIfAtBottom);
      };
    }, [location.pathname]);
  return (
    <footer>
            <Modal
                   open={open}
                   onClose={handleOpen}
                   aria-labelledby="modal-modal-title"
                   aria-describedby="modal-modal-description"
                 >
                   <Box sx={style}>
                     <div className="d-flex flex-row-reverse ">
                       <IconButton onClick={handleOpen}>
                        <CloseIcon />
                       </IconButton>
                     </div>
                      <ContactUs />
                     </Box>
                     </Modal>
           <Box
      component="footer"
      className="container-fluid"
      sx={{
        backgroundColor: '#121212',
        color: '#fff',
        py: 2,
        px: 3,
      }}
    >
      <div className="row align-items-center">
        {/* Left Section */}
        <div className="col-md-6 text-center text-md-start mb-2 mb-md-0">
          <Typography variant="body3">
          © 2025 Azi Tech Global. All Rights Reserved.{' '} | <Link sx={{cursor:'pointer'}} onClick={handleOpen} variant="body2">
  {'Contact Us'}
</Link>
{/* <span onClick={handleOpen}> Contact Us </span> */}
          
          </Typography>
        </div>

        {/* Right Section - Social Icons */}
        <div className="col-md-6 text-center text-md-end">
          <Stack direction="row" spacing={1} justifyContent="center">
            {
              socialMedia.map((data,idx) => {
                return(
                  <IconButton  href={data.info} target="_blank" rel="noopener noreferrer" color="inherit" sx={{fontSize:"100px"}} key={idx}>
                    {data.icon.large}
                  </IconButton>
                )
              })
            }
          </Stack>
        </div>
      </div>
    </Box>
    <Button sx={{
                className:'z-2',    
                position: isShortPage ? 'absolute' : 'fixed',
                bottom: isShortPage ? '10vh' : 25,
                right:20,
                borderRadius:"25px",
                display: isAtBottom ? 'none' : '',
                 backgroundColor: '#121212',
                 color:"white"
              }} onClick={handleOpen} endIcon={<SendIcon />}>
                Reach Us
              </Button>
         
    </footer>
  );
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  scroll: "auto",
  maxHeight: "90vh",
  overflowY: "auto",
};
export default Footer;
